window.CloudNineGalleryViewer = function(galleryScope, photoCardSelector, modelNoteForCard) {
  const photoDialog = document.createElement("dialog");
  photoDialog.className = "photo-viewer";
  photoDialog.setAttribute("aria-label", "Product image viewer");
  photoDialog.innerHTML = '<div class="photo-toolbar"><span class="photo-count" aria-live="polite"></span><button type="button" class="photo-zoom" aria-label="Zoom in"><svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M152,112a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"/></svg></button><button type="button" class="photo-close" aria-label="Close image"><svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg></button></div><div class="photo-stage"><img draggable="false" alt=""></div><button type="button" class="photo-prev" aria-label="Previous image"><svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg></button><button type="button" class="photo-next" aria-label="Next image"><svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg></button><p class="photo-hint">Swipe to browse \xB7 Double-tap or pinch to zoom</p><p class="photo-model-note" aria-live="polite" hidden></p>';
  galleryScope.append(photoDialog);
  const stage = photoDialog.querySelector(".photo-stage"), photo = stage.querySelector("img");
  const hint = photoDialog.querySelector('.photo-hint');
  const modelCaption = photoDialog.querySelector('.photo-model-note');
  stage.append(hint);
  let hintTimer;
  function dismissHint() {
    clearTimeout(hintTimer);
    hint.classList.add('is-dismissed');
    hint.setAttribute('aria-hidden', 'true');
  }
  function showHint() {
    clearTimeout(hintTimer);
    hint.classList.remove('is-dismissed');
    hint.removeAttribute('aria-hidden');
    hintTimer = setTimeout(dismissHint, 4000);
  }
  let photos = [], photoIndex = 0, scale = 1, panX = 0, panY = 0, returnFocus, lastTap = 0, gesture = null, previousOverflow = "";
  const pointers = /* @__PURE__ */ new Map();
  function paintPhoto() {
    if (scale > 1 && !hint.classList.contains('is-dismissed')) dismissHint();
    const box = stage.getBoundingClientRect();
    const maxX = box.width * (scale - 1) / 2, maxY = box.height * (scale - 1) / 2;
    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
    photo.style.transform = "translate(" + panX + "px," + panY + "px) scale(" + scale + ")";
    photoDialog.querySelector(".photo-zoom").innerHTML = scale > 1 ? '<svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M152,112a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h64A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"/></svg>' : '<svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor"><path d="M152,112a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"/></svg>';
    photoDialog.querySelector(".photo-zoom").setAttribute("aria-label", scale > 1 ? "Reset zoom" : "Zoom in");
  }
  function resetPhoto() {
    scale = 1;
    panX = panY = 0;
    paintPhoto();
  }
  function showPhoto(index) {
    dismissHint();
    photoIndex = (index + photos.length) % photos.length;
    photo.src = photos[photoIndex].src;
    photo.alt = photos[photoIndex].alt;
    photoDialog.querySelector(".photo-count").textContent = photoIndex + 1 + " / " + photos.length;
    photoDialog.querySelectorAll(".photo-prev,.photo-next").forEach((button) => button.hidden = photos.length < 2);
    resetPhoto();
  }
  function toggleZoom() {
    scale = scale > 1 ? 1 : 2.5;
    panX = panY = 0;
    paintPhoto();
  }
  photoDialog.querySelector(".photo-close").onclick = () => photoDialog.close();
  photoDialog.querySelector(".photo-zoom").onclick = toggleZoom;
  photoDialog.querySelector(".photo-prev").onclick = () => showPhoto(photoIndex - 1);
  photoDialog.querySelector(".photo-next").onclick = () => showPhoto(photoIndex + 1);
  photoDialog.addEventListener("close", () => {
    dismissHint();
    document.body.style.overflow = previousOverflow;
    pointers.clear();
    gesture = null;
    returnFocus?.focus({preventScroll: true});
  });
  photoDialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
      event.preventDefault();
      showPhoto(photoIndex + (event.key === "ArrowRight" ? 1 : -1));
    }
    if (event.key === "+" || event.key === "=") {
      event.preventDefault();
      scale = Math.min(4, scale + 0.5);
      paintPhoto();
    }
    if (event.key === "-") {
      event.preventDefault();
      scale = Math.max(1, scale - 0.5);
      paintPhoto();
    }
  });
  stage.addEventListener("pointerdown", (event) => {
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    stage.setPointerCapture(event.pointerId);
    if (pointers.size === 1) gesture = { x: event.clientX, y: event.clientY, panX, panY, time: Date.now(), moved: false, pinch: false };
    if (pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      gesture = { distance: Math.hypot(a.x - b.x, a.y - b.y), scale, pinch: true, moved: true };
    }
  });
  stage.addEventListener("pointermove", (event) => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      scale = Math.max(1, Math.min(4, gesture.scale * Math.hypot(a.x - b.x, a.y - b.y) / gesture.distance));
      paintPhoto();
    } else if (!gesture.pinch) {
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (Math.hypot(dx, dy) > 8) gesture.moved = true;
      if (scale > 1) {
        panX = gesture.panX + dx;
        panY = gesture.panY + dy;
        paintPhoto();
      }
    }
  });
  function endPointer(event) {
    if (!gesture) return;
    const g = gesture;
    pointers.delete(event.pointerId);
    if (pointers.size) return;
    gesture = null;
    if (g.pinch) return;
    const dx = event.clientX - g.x, dy = event.clientY - g.y;
    if (scale === 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      showPhoto(photoIndex + (dx < 0 ? 1 : -1));
      lastTap = 0;
    } else if (!g.moved && Date.now() - g.time < 350) {
      const now = Date.now();
      if (now - lastTap < 300) {
        toggleZoom();
        lastTap = 0;
      } else lastTap = now;
    }
  }
  stage.addEventListener("pointerup", endPointer);
  stage.addEventListener("pointercancel", () => {
    pointers.clear();
    gesture = null;
  });
  stage.addEventListener("wheel", (event) => {
    event.preventDefault();
    scale = Math.max(1, Math.min(4, scale - event.deltaY * 5e-3));
    paintPhoto();
  }, { passive: false });
  galleryScope.querySelectorAll(photoCardSelector).forEach((card) => {
    card.tabIndex = 0;
    card.setAttribute("role", "button");
    card.setAttribute("aria-label", "Enlarge product image");
  });
  let photoPointerDown;
  galleryScope.addEventListener("pointerdown", (event) => {
    if (event.target.closest(photoCardSelector)) photoPointerDown = { x: event.clientX, y: event.clientY };
  });
  function open({photos: items, index = 0, trigger, modelNote, colorControls}) {
    const alreadyOpen = photoDialog.open;
    photoDialog.querySelector('.photo-color-footer')?.remove();
    if (colorControls) photoDialog.append(colorControls);
    photos = items;
    modelCaption.textContent = modelNote || '';
    modelCaption.hidden = !modelNote;
    if (!alreadyOpen) { returnFocus = trigger; previousOverflow = document.body.style.overflow; }
    document.body.style.overflow = "hidden";
    if (!alreadyOpen) photoDialog.showModal();
    showPhoto(index);
    showHint();
    photoDialog.querySelector(".photo-close").focus({preventScroll: true});
  }
  function openCardPhoto(card) {
    const image = card.querySelector("img");
    const modelNote = modelNoteForCard(card);
    if (card.matches(".equal-photo-card,.peek-slide")) {
      const images = [...card.parentElement.querySelectorAll("img[data-media-id]")];
      open({photos: images.map((item) => ({ src: item.dataset.zoomSrc, alt: item.alt })), index: images.indexOf(image), trigger: card, modelNote});
    } else {
      open({photos: [{ src: card.dataset.lightboxSrc, alt: image.alt }], trigger: card, modelNote});
    }
  }
  galleryScope.addEventListener("click", (event) => {
    const card = event.target.closest(photoCardSelector);
    if (!card || photoPointerDown && Math.hypot(event.clientX - photoPointerDown.x, event.clientY - photoPointerDown.y) > 12) return;
    openCardPhoto(card);
  });
  galleryScope.addEventListener("keydown", (event) => {
    const card = event.target.closest(photoCardSelector);
    if (card && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      openCardPhoto(card);
    }
  });
  return {open};
};
